import { useContext } from 'react';

import { useMutation } from '@tanstack/react-query';
import axios from 'axios';

import { ConfigContext } from '../../../aurr/contexts/ConfigContext';
import LoginContext from '../../../aurr/contexts/LoginContext';
import { ApiRequestProps } from '../../../common/interface';
import { Collection } from '../../../common/type';
import {
  COLLECTION_CREATE_MUTATE_KEY,
  COLLECTIONS_PROVIDER,
} from '../constants';

type Props = ApiRequestProps;

export const useCreateCollection = (props: Props) => {
  const { COMMUNITY_FUNCTIONS_URL } = useContext(ConfigContext);
  const { baseURL, params = {} } = props;
  const { access_token } = useContext(LoginContext);

  const parsedBaseURL = baseURL || COMMUNITY_FUNCTIONS_URL;

  const axiosConfig = {
    baseURL: `${parsedBaseURL}/store/v1/collections`,
    headers: {
      ...(access_token && { authorization: `Bearer ${access_token}` }),
    },
  };
  const api = axios.create(axiosConfig);

  return useMutation({
    mutationKey: [COLLECTION_CREATE_MUTATE_KEY, parsedBaseURL],
    mutationFn: async (newItem: Partial<Collection>) => {
      return api.post('', newItem, {
        params: {
          provider: params?.provider || COLLECTIONS_PROVIDER,
          ...params,
        },
      });
    },
  });
};
